module.exports = "<div id=ficheNav></div>\n<div id=ficheContent></div>";